/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type labelRow_label = {
    readonly id: string;
    readonly name: string | null;
    readonly color: string | null;
    readonly taskCount: number | null;
    readonly projectCount: number | null;
    readonly peopleCount: number | null;
    readonly " $refType": "labelRow_label";
};
export type labelRow_label$data = labelRow_label;
export type labelRow_label$key = {
    readonly " $data"?: labelRow_label$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"labelRow_label">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "labelRow_label",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taskCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "peopleCount",
      "storageKey": null
    }
  ],
  "type": "Label"
};
(node as any).hash = '3b4b143d1e3cc2f8d4e35d4c295ead22';
export default node;
